/*********************************************************************************************
	* Changing color header when opening the menu
*/
function mmHeaderColorChange(){
	const header = document.querySelector(".mm-header");
	header.classList.add('mm-header-scroll');
}

/*********************************************************************************************
	* Changing color header when scrolling
*/

document.addEventListener("DOMContentLoaded", function () {
    const header = document.querySelector('.mm-header');

    const desktopBarHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--announcement-bar-height'));
    const mobileBarHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--announcement-bar-height-mobile'));

    function isMobile() {
        return window.matchMedia("(max-width: 768px)").matches;
    }

    function handleScroll() {
        const scrollThreshold = isMobile() ? mobileBarHeight : desktopBarHeight;
        if (window.scrollY > scrollThreshold) {
            header.classList.add('mm-header-scroll');
        } else {
            header.classList.remove('mm-header-scroll');
        }
    }

    window.addEventListener('scroll', handleScroll);
});


/*********************************************************************************************
	* Add background filter on hover over mega menu links.
*/
function hoverBgFilter() {
    const header = document.querySelector('.mm-header');
    const megaMenuLinks = document.querySelectorAll('.mm-header-link-mega-menu');
    const filter = document.querySelector('.mm-filter-mega-menu');
    
    if (!header || !filter) return;

    megaMenuLinks.forEach(megaMenuLink => {
        megaMenuLink.addEventListener('mouseenter', () => {
            if (!header.classList.contains('mm-open')) {
                showBgFilter();
            }
        });
    });

    // header.addEventListener('mouseleave', () => {
    //     if (!header.classList.contains('mm-open')) {
    //         hideBgFilter();
    //     }
    // });
}

/*********************************************************************************************
	* Show background filter.
*/
function showBgFilter() {
	const filter = document.querySelector('.mm-filter-mega-menu');
	
    filter.classList.add("active");
}

/*********************************************************************************************
	* Hide background filter.
*/
function hideBgFilter() {
    const filter = document.querySelector('.mm-filter-mega-menu'); 

    filter.classList.remove("active");
}

/*********************************************************************************************
	* Open external links in a new tab unless it's the consent modale.
*/
function externalLink() {
	var links = document.links;
    for (let i = 0, linksLength = links.length; i < linksLength; i++) {
        if (!links[i].classList.contains('consent-wrapper') && links[i].hostname !== window.location.hostname) {
            links[i].target = '_blank';
            links[i].rel = 'noreferrer noopener';
        }
    }
}

/*********************************************************************************************
	* Toggle the mobile menu.
*/
function mmMobileMenu() {
	const header = document.querySelector("header");
	const icons = document.querySelectorAll(".mm-header-burger");
	const mobileMenu = document.querySelector(".mm-mobile-menu-wrapper");

	document.querySelector("html").classList.add("stop-scrolling");
	header.classList.add("mm-open");
	mmHeaderColorChange();
	mobileMenu.classList.add("mm-menu-open");
	icons.forEach(icon => icon.classList.add("mm-open"));
	
	updateMobileMenuPosition();
	showBgFilter();
}

/*********************************************************************************************
	* Open the mobile menu from the desktop menu links
*/
function mmOpenSubmenuMobileFromDesk(targetClass) {
	const header = document.querySelector("header");
	const icons = document.querySelectorAll(".mm-header-burger");
	const targetMenu = document.querySelector(targetClass);
	const mobileMenuSecondary = targetMenu.querySelector(".mm-header-mobile-sublinks");
	const sublinks = document.querySelectorAll('.mm-header-mobile-sublinks');

	let headerMenu = document.querySelector('.mm-header');
	let headerHeight = headerMenu.offsetHeight;
	let headerMenuTop = headerMenu.getBoundingClientRect().top;

	document.querySelector("html").classList.add("stop-scrolling");
	header.classList.add("mm-open");
	document.querySelector(".mm-header").classList.add("mm-header-scroll");
	sublinks.forEach(sublink => sublink.classList.remove('mm-mobile-menu-elem-slided'));
	targetMenu.classList.add('mm-menu-open');
	targetMenu.style.top = `calc(${headerHeight}px + ${headerMenuTop}px)`;
	targetMenu.style.height = `calc(var(--doc-height) - (${headerHeight}px + ${headerMenuTop}px))`;
	mobileMenuSecondary.style.height = `calc(var(--doc-height) - (${headerHeight}px + ${headerMenuTop}px))`;
	icons.forEach(icon => icon.classList.add("mm-open"));
	showBgFilter();
}

/*********************************************************************************************
	* Close the mobile menu.
*/
function mmCloseMobileMenu() {
	const header = document.querySelector("header");
	const icons = document.querySelectorAll(".mm-header-burger");
	const mobileMenu = document.querySelector(".mm-mobile-menu-wrapper");

	document.querySelector("html").classList.remove("stop-scrolling");
	header.classList.remove("mm-open");
	mobileMenu.classList.remove("mm-menu-open");
	icons.forEach(icon => icon.classList.remove("mm-open"));
	hideBgFilter();
}

/*********************************************************************************************
	* Close the mobile submenu.
*/
function mmCloseAllSubmenus() {
	const subMenus = document.querySelectorAll('.mm-header-mobile-sublinks')

	subMenus.forEach(function(subMenu) {
		subMenu.classList.remove('mm-mobile-menu-elem-slided');
	});
}

/*********************************************************************************************
	* Open the search bar mobile
*/
function mmOpenSearchBarMobile() {
	const searchBar = document.querySelector('.mm-header-search-container');

	// Toggle the class
	searchBar.classList.toggle('mm-open');

	if (searchBar.classList.contains('mm-open')) {
		// If search bar is open, adjust its position
		updateSearchBarPosition();
	} else {
		// If search bar is closed, reset its position
		searchBar.style.top = '-200%';
	}

	// Update the mobile menu position (if necessary)
	updateMobileMenuPosition();
}


/*********************************************************************************************
	* Adjust position & height of the menu
*/
function updateMobileMenuPosition() {
    const menuWrapper = document.querySelector('.mm-mobile-menu-wrapper');
    const searchBar = document.querySelector('.mm-header-search-container');
    const headerMenu = document.querySelector('.mm-header');
    const announceBar = document.querySelector('.mm-section-announcement-bar');

    let headerHeight = headerMenu.offsetHeight;

    if (searchBar.classList.contains('mm-open')) {
        headerHeight += searchBar.offsetHeight;
    }

    if (announceBar) {
		const announceBarHeight = window.innerWidth > 768 ? 
        parseInt(getComputedStyle(document.documentElement).getPropertyValue('--announcement-bar-height')) :
        parseInt(getComputedStyle(document.documentElement).getPropertyValue('--announcement-bar-height-mobile'));
        const currentHeight = Math.max(0, announceBarHeight - window.scrollY);
        headerHeight += currentHeight;
    }

    menuWrapper.style.top = `${headerHeight}px`;
    menuWrapper.style.height = `calc(100vh - ${headerHeight}px)`;
}
/*********************************************************************************************
	* Adjust position & height of the menu
*/
function updateSearchBarPosition() {
    const searchBar = document.querySelector('.mm-header-search-container');
    const headerMenu = document.querySelector('.mm-header');
    const announceBar = document.querySelector('.mm-section-announcement-bar');

    let headerHeight = headerMenu.offsetHeight;

    if (announceBar) {
		const announceBarHeight = window.innerWidth > 768 ? 
        parseInt(getComputedStyle(document.documentElement).getPropertyValue('--announcement-bar-height')) :
        parseInt(getComputedStyle(document.documentElement).getPropertyValue('--announcement-bar-height-mobile'));
        const currentHeight = Math.max(0, announceBarHeight - window.scrollY);
        headerHeight += currentHeight;
    }

    searchBar.style.top = `${headerHeight}px`;
}


/*********************************************************************************************
	* Show the next sub-menu in the mobile menu.
	* 
	* @param {string} elemToShowClass - The CSS selector of the element to show.
*/
function mmMobileMenuShowNext(elemToShowClass) {
    var elemToShow = document.querySelector(elemToShowClass);
    elemToShow.classList.add('mm-mobile-menu-elem-slided');
}

/*********************************************************************************************
	* Show the previous sub-menu in the mobile menu.
	* 
	* @param {string} elemToShowClass - The CSS selector of the element to show.
*/
function mmMobileMenuShowPrev(elemToShowClass) {
    var elemToShow = document.querySelector(elemToShowClass);
    elemToShow.classList.remove('mm-mobile-menu-elem-slided');
}

/*********************************************************************************************
	* Handle dropdown behavior.
*/
function handleDropdown() {
    const dropWrapper = document.querySelectorAll('[data-drop="dropdown"]');

    // Open the first dropdown by default
    // if (dropWrapper.length > 0) {
    //     dropWrapper[0].classList.add('active');
    //     const firstContent = dropWrapper[0].nextElementSibling;
    //     if (firstContent) {
    //         firstContent.style.maxHeight = firstContent.scrollHeight + 'px';
    //     }
    // }

    dropWrapper.forEach((item) => {
        item.addEventListener('click', function () {
            // Close all other dropdowns
            dropWrapper.forEach((el) => {
                if (el !== this) {
                    el.classList.remove('active');
                    const sibling = el.nextElementSibling;
                    if (sibling) {
                        sibling.style.maxHeight = null;
                    }
                }
            });

            // Toggle the current dropdown
            this.classList.toggle('active');

            const content = this.nextElementSibling;
            if (content) {
                if (content.style.maxHeight) {
                    content.style.maxHeight = null;
                } else {
                    content.style.maxHeight = content.scrollHeight + 'px';
                }
            }
        });
    });
}

/*********************************************************************************************
	* Initialize parallax effect for slide images.
	*
*/
const mmInitParallax = () => {
    const images = document.querySelectorAll(".mm-slide-image");
    if (!images.length) return;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const slideImage = entry.target;
                const covers = slideImage.querySelectorAll(".mm-slide-image-cover");
                if (!covers.length) return;

                covers.forEach(cover => {
                    gsap.to(cover, {
                        yPercent: 20,
                        ease: "none",
                        scrollTrigger: {
                            trigger: slideImage,
                            start: "top bottom",
                            end: "bottom top",
                            scrub: true
                        }
                    });
                });

                observer.unobserve(slideImage);
            }
        });
    }, {
        rootMargin: "0px 0px 200px 0px"
    });

    images.forEach(image => observer.observe(image));
};

/*********************************************************************************************
 * Handles lazy loading of videos based on viewport size
 *
 */
const mmInitVideoLazy = () => {
	const videos = document.querySelectorAll(".mm-video-lazy");
	if (!videos.length) return;

	const loadVideo = (video) => {
		if (video.dataset.loaded !== "true") {
            const source = video.querySelector('source');
			if (!source || !source.dataset.src) return;

			source.src = source.dataset.src;
			video.preload = "metadata";
			video.dataset.loaded = "true";

            video.load();
            video.play().catch(err => console.warn('Auto-play failed:', err));
		}
	};

	const unloadVideo = (video) => {
		if (video.dataset.loaded === "true") {
            video.pause();
            video.currentTime = 0;
            video.dataset.loaded = "false";
        }
	};

	const handleVideoVisibility = (video) => {
		const isMobile = window.matchMedia("(max-width: 768px)").matches;
		const isDesktop = video.classList.contains("mm-desktop");
		const isMobileVideo = video.classList.contains("mm-mobile");

		const shouldPlay = (!isDesktop && !isMobileVideo) || 
		(isDesktop && !isMobile) || 
		(isMobileVideo && isMobile);

		if (shouldPlay) {
			loadVideo(video);
			video.classList.add("mm-video-loaded");
		} else {
			video.classList.remove("mm-video-loaded");
		}
	};

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					handleVideoVisibility(entry.target);
				} else {
					unloadVideo(entry.target);
				}
			});
		},
		{
			rootMargin: "50px 0px",
			threshold: 0.1,
		}
	);

	videos.forEach((video) => observer.observe(video));

	let resizeTimeout;
	window.addEventListener("resize", () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			videos.forEach((video) => {
				if (video.classList.contains("mm-video-loaded")) {
					handleVideoVisibility(video);
				}
			});
		}, 250);
	});
};

/*********************************************************************************************
	* Set the document height CSS variable to the current window height.
*/
const documentHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty('--doc-height', `${window.innerHeight}px`);
}

/*********************************************************************************************
	* Custom element for product recommendations
*/
class ProductRecommendations extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            fetch(this.dataset.url)
                .then((response) => response.text())
                .then((text) => {
                    const html = document.createElement("div");
                    html.innerHTML = text;
                    const recommendations = html.querySelector("product-recommendations");

                    if (recommendations && recommendations.innerHTML.trim().length) {
                        this.innerHTML = recommendations.innerHTML;
                        // Réinitialiser la wishlist pour les nouvelles cartes de produits
                        if (window.wishlistManager) {
                            window.wishlistManager.initButtons();
                        }
                    } else {
                        const parentElement = this.closest('.mm-section');
                        if (parentElement) {
                            parentElement.style.display = 'none';
                        }
                    }
                })
                .catch((e) => {
                    console.error(e);
                });
        };

        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
    }
}

customElements.define("product-recommendations", ProductRecommendations);

/*********************************************************************************************
	* Initialize the Instagram scroll effect.
*/
const mmInitInstagramScroll = () => {
    if (typeof gsap === 'undefined') {
        console.warn('GSAP n\'est pas chargé');
        return;
    }

    gsap.registerPlugin(ScrollTrigger);

    const container = document.querySelector('.mm-instagram-container');
    if (!container) return;

    const containerText = container.querySelector('.mm-instagram-text-container');
    const items = container.querySelectorAll('.mm-instagram-item');
    
    // Configuration des états selon la taille d'écran
    const config = {
        desktop: {
            initial: [
                {
                    top: '18%',
                    left: '30%',
                    width: '200px',
                    height: '200px',
                    zIndex: '1'
                },
                {
                    top: '15%',
                    right: '42%',
                    width: '190px',
                    height: '190px',
                    zIndex: '3'
                },
                {
                    top: '20%',
                    right: '30%',
                    width: '180px',
                    height: '200px',
                    zIndex: '5'
                },
                {
                    bottom: '15%',
                    right: '37%',
                    width: '190px',
                    height: '190px',
                    zIndex: '4'
                },
                {
                    bottom: '20%',
                    left: '34%',
                    width: '175px',
                    height: '175px',
                    zIndex: '2'
                }
            ],
            final: [
                {
                    top: '9%',
                    left: '-5%',
                    width: '250px',
                    height: '250px'
                },
                {
                    top: '-22%',
                    right: '52%',
                    width: '260px',
                    height: '260px'
                },
                {
                    top: '-26%',
                    right: '4%',
                    width: '290px',
                    height: '325px'
                },
                {
                    bottom: '-15%',
                    right: '7%',
                    width: '250px',
                    height: '250px'
                },
                {
                    bottom: '-22%',
                    left: '20%',
                    width: '250px',
                    height: '250px'
                }
            ]
        },
        mobile: {
            initial: [
                {
                    top: '28%',
                    left: '23%',
                    width: '200px',
                    height: '200px',
                    zIndex: '1'
                },
                {
                    top: '25%',
                    right: '40%',
                    width: '190px',
                    height: '190px',
                    zIndex: '3'
                },
                {
                    top: '30%',
                    right: '23%',
                    width: '180px',
                    height: '200px',
                    zIndex: '5'
                },
                {
                    bottom: '26%',
                    right: '34%',
                    width: '190px',
                    height: '190px',
                    zIndex: '4'
                },
                {
                    bottom: '30%',
                    left: '28%',
                    width: '175px',
                    height: '175px',
                    zIndex: '2'
                }
            ],
            final: [
                {
                    top: '10%',
                    left: '-25%'
                },
                {
                    top: '-6%',
                    right: '25%'
                },
                {
                    top: '5%',
                    right: '-30%'
                },
                {
                    bottom: '7%',
                    right: '-32%'
                },
                {
                    bottom: '-8%',
                    left: '20%'
                }
            ]
        }
    };

    const createAnimation = () => {
        const isMobile = window.innerWidth < 990;
        const isMobileSm = window.innerWidth < 768;
        const currentConfig = isMobile ? config.mobile : config.desktop;
        const startTarget = isMobileSm ? "top bottom+=100" : "top bottom";
        const endTarget = isMobileSm ? "bottom bottom-=200" : "bottom center";

        items.forEach((item, index) => {
            gsap.fromTo(item, 
                currentConfig.initial[index],
                {
                    ...currentConfig.final[index],
                    scrollTrigger: {
                        trigger: containerText,
                        start: startTarget,
                        end: endTarget,
                        scrub: 1,
                        // markers: true
                    }
                }
            );
        });
    };

    // Créer l'animation initiale
    createAnimation();

    // Recréer l'animation au redimensionnement
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(createAnimation, 250);
    });
};

// Initialisation
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mmInitInstagramScroll);
} else {
    mmInitInstagramScroll();
}

/*********************************************************************************************
	* Split text animation in edito section.
*/
const mmInitEditoSplitText = () => {
	const splitTexts = document.querySelectorAll('.edito-split-text');
	splitTexts.forEach(text => {
		Splitting({ target: text, by: 'chars' });
	});

	// Animation au scroll
	gsap.utils.toArray('.edito-split-text').forEach(text => {
		const chars = text.querySelectorAll('.char');
		
		gsap.to(chars, {
			scrollTrigger: {
				trigger: text,
				start: 'top 80%',
				end: 'bottom center',
				scrub: true
			},
			opacity: '1',
			stagger: 0.1,
			duration: 1
		});
	});
}

/*********************************************************************************************
	* Livraison panel
*/
function mmOpenShippingInformations() {
    document.querySelector(`.mm-shipping-informations-panel-wrapper`).classList.remove('mm-hidden');
    document.querySelector("html").classList.add("stop-scrolling");
}

function mmCloseShippingInformations() {
    document.querySelectorAll('.mm-shipping-informations-panel-wrapper').forEach(shippingPanel => {
        shippingPanel.classList.add('mm-hidden');
    });
    document.querySelector("html").classList.remove("stop-scrolling");
}

/*********************************************************************************************
	* Adjust panel positions
*/
const adjustPanelPositions = (() => {
    const header = document.querySelector(".mm-header");
    const panels = [...document.querySelectorAll(".mm-panel-filter, .mm-panel-container")];
    const containers = [...document.querySelectorAll(".mm-panel-container")];
    
    if (!header || !panels.length) {
        console.warn("Elements requis non trouvés pour adjustPanelPositions");
        return () => {};
    }

    const updatePositions = () => {
        const headerHeight = header.getBoundingClientRect().height;
        panels.forEach(panel => panel.style.top = `${headerHeight}px`);
        containers.forEach(container => {
            container.style.height = `calc(100vh - ${headerHeight}px)`;
        });
    };

    return updatePositions;
})();


/*********************************************************************************************
 * Handle contact form submission and display success message.
 */
document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('contact_form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
        e.preventDefault(); // Empêche le rechargement de la page

        const formData = new FormData(form);
        const successMessage = document.querySelector('.mm-form-success-message');

        // Envoi des données via fetch (AJAX)
        fetch(form.action, {
            method: 'POST',
            body: formData,
            headers: {
                'Accept': 'application/json', // Accepte le format JSON si le serveur le supporte
            },
        })
            .then(response => {
                if (response.ok) {
                    // Affiche le message de succès
                    if (successMessage) {
                        successMessage.classList.remove('mm-none'); // Affiche le message
                        successMessage.classList.add('mm-block'); // Ajoutez une classe pour le style (optionnel)
                    }
                    form.reset(); // Réinitialise le formulaire
                } else {
                    console.error('Erreur lors de la soumission du formulaire.');
                }
            })
            .catch(error => {
                console.error('Une erreur s\'est produite :', error);
            });
    });
});


/************************************************************************************************/
// Loaded Listenner
document.addEventListener("DOMContentLoaded", () => {
    //hoverBgFilter();
    handleDropdown();
	externalLink();
	mmInitParallax();
	mmInitVideoLazy();
	mmInitInstagramScroll();
	documentHeight();
	mmInitEditoSplitText();
	adjustPanelPositions();
});

/************************************************************************************************/
// Scroll Listenner
window.addEventListener("scroll", () => {
	const searchBar = document.querySelector('.mm-header-search-container');
	
	if (searchBar.classList.contains('mm-open')) {
		updateSearchBarPosition();
	}
	updateMobileMenuPosition();
});

/************************************************************************************************/
// Resized Listenner
window.addEventListener('resize', () => {
	documentHeight();
	adjustPanelPositions();
});